<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <h2 class="text-text-neutral-primary text-base font-medium">
          {{ $t('general.search') }}
        </h2>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="space-y-4 px-4 pb-4">
        <div
          class="flex h-[180px] w-full flex-col justify-end rounded-xl bg-cover bg-no-repeat"
          :style="{ backgroundImage: `url(${currentSpecial?.image_url})` }"
        >
          <div
            class="bg-static-black/20 space-y-1 rounded-xl px-4 py-3"
            :style="{
              backdropFilter: 'blur(2px)',
            }"
          >
            <p v-if="isEvent" class="text-static-white font-semibold">
              {{ currentSpecial.title }}
            </p>
            <p v-else class="text-static-white font-semibold">
              {{ $t('specialOffer.details.directionsFrom', { city: depCity }) }}
            </p>
            <p v-if="isEvent" class="text-static-white text-sm">
              {{ currentSpecial.location.city.name }},
              {{ currentSpecial.location.country.name }}
              ·
              {{ formatDate(currentSpecial.date) }}
            </p>
            <template v-else>
              <p v-if="shouldShowSubtitle" class="text-static-white text-sm">
                {{ currentSpecial.subtitle }}
              </p>
              <DirectionsDisplay
                v-else
                :special="currentSpecial"
                :text-class="
                  shouldTruncate
                    ? 'text-static-white text-sm line-clamp-2'
                    : 'text-static-white text-sm'
                "
                :show-icon="false"
              />
            </template>
          </div>
        </div>
        <SearchForm
          source="special_offer_details"
          @onSearchFormSubmit="handleSearchFormSubmit"
        />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet, FreeHeader, FreeCloseButton } from 'freedom-shared';
  import { useRouter } from 'vue-router';
  import type { specialOffers } from 'shared';
  import { computed } from 'vue';
  import dayjs from 'dayjs';

  import { SearchForm } from '@/widgets/search-form';

  import { amplitudeEventsConfig } from '@/shared/config';

  import DirectionsDisplay from './DirectionsDisplay.vue';

  const props = defineProps<{
    name: string;
    currentSpecial: specialOffers.Special;
    depCity: string;
  }>();

  const router = useRouter();
  const isEvent = computed(() => props.currentSpecial?.type === 'EVENT');

  // Считаем количество городов/стран в массиве routes
  const routesCount = computed(() => {
    const routes = props.currentSpecial?.directions?.routes;
    return routes?.length || 0;
  });

  // Если 14+ элементов → показываем subtitle
  const shouldShowSubtitle = computed(() => routesCount.value >= 14);

  // Если 10-13 элементов → обрезаем через line-clamp-2
  const shouldTruncate = computed(
    () => routesCount.value >= 10 && routesCount.value <= 13,
  );

  const handleSearchFormSubmit = (hashCode: string, query?: string) =>
    router.push({
      name: 'OffersResults',
      params: {
        hashCode,
        source: amplitudeEventsConfig.SERP_OPEN_SOURCE.SPECIAL_OFFERS,
      },
      query: { iata: query },
    });

  const formatDate = (date: string) => {
    return dayjs(date).format('D MMMM, YYYY');
  };
</script>
